import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { useDevToolsSetting } from '~/features/settings/devTools';

import { queryClient } from './queryClient';

export const QueryProvider = ({ children }: { children: React.ReactNode }) => {
  const { isDevToolsEnabled } = useDevToolsSetting();

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {isDevToolsEnabled ? (
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
      ) : null}
    </QueryClientProvider>
  );
};
